'use strict';

const {
  clockTimeLeft,
  textTimeLeft,
  progressComplete,
} = require('../../common/helpers');

class JuiceProgramModel {
  constructor({ juiceProgramStartTime, juiceProgramEndTime } = {}) {
    if (juiceProgramStartTime) {
      this.startAt = new Date(juiceProgramStartTime);
    }
    if (juiceProgramEndTime) {
      this.endAt = new Date(juiceProgramEndTime);
    }
  }

  timeLeft() {
    const clockTime = clockTimeLeft(this.endAt);
    const textTime = textTimeLeft(this.endAt);

    if (clockTime && textTime && this.startAt) {
      const progress = progressComplete(this.startAt, this.endAt);
      return { clockTime, progress, textTime };
    }
    return null;
  }
}

module.exports = JuiceProgramModel;
